module.exports = __webpack_public_path__ + "static/github-eecb1b2fd55f16576663eeccf0e11021.png";